export default {
  common: {
    esg: {
      category: 'Kategorie',
      environment: 'Umwelt',
      society: 'Soziales',
      governance: 'Governance',
      other: 'Andere',
      comprehensive: 'Gesamt',
      // basic: '',
    },
    btn: {
      cancel: 'Abbrechen',
      add: 'Hinzufügen',
      create: 'Erstellen',
      update: 'Aktualisieren',
      apply: 'Bewerben',
      close: 'Schließen',
      create_new: 'Neu erstellen',
      edit: 'Bearbeiten',
      detail: 'Detail',
      view_detail: 'Detail',
      delete: 'Löschen',
      change: 'Ändern',
      confirm: 'Bestätigen',
      clear: 'Zurücksetzen',
      download: 'Herunterladen',
      save: 'Speichern',
      register: 'Registrieren',
      check_answer: 'Antwort prüfen',
      score_card_list: 'Scorecard-Liste',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: 'Bulk-Download',
    },
    link: {
      delete: 'Löschen',
      back: 'Zurück',
    },
    sentence: {
      back_to_login: 'Zurück zur Anmeldung',
      back_to_dashboard: 'Zurück zum Dashboard',
      not_applicable: 'Nicht zutreffend*',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: 'Umfrage',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: 'Wählen Sie eine Umfrage',
      target_year: 'Jahr',
      target_year_text: 'Jahr auswählen',
      target_company: 'Unternehmen',
      target_company_text: 'Wählen Sie ein Unternehmen',
      total: 'Alle: {total}',
    },
    label: {
      required: 'Erforderlich',
      optional: 'Optional',
      year: 'Jahr',
    },
    form: {
      search_word: {
        label: 'Kostenlose Wortsuche',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: 'Datum der Ausgabe',
      evaluation_expires_date: 'Datum des Verfalls',
      answer_expires_date: 'Deadline',
      // last_updated_date: '',
    },
    error: {
      code_0005: 'Authentifizierung fehlgeschlagen. Bitte melden Sie sich erneut an',
      code_0007: 'Diese Frage ist obligatorisch',
      code_5001: 'Seite nicht gefunden.',
      code_0001: 'Die letzte Umfrage wurde bereits abgeschickt',
      code_0002: 'Aktualisierung fehlgeschlagen, da die letzten Daten von einem anderen Gerät aktualisiert wurden. Bitte laden Sie neu und versuchen Sie die Aktualisierung erneut.',
      code_0003: 'Das Löschen der Datei ist fehlgeschlagen. Bitte löschen Sie, nachdem Sie mindestens eine Frage beantwortet haben.',
      code_0006: 'Der Benutzer ist bereits registriert',
      code_0004: 'Diese Datei überschreitet die hochladbare Dateigröße. Bitte beachten Sie, dass die Größe innerhalb von 50 MB liegen muss.',
      code_9999: 'Ein unerwarteter Fehler ist aufgetreten',
    },
    evaluation: {
      title: 'Bewertung anfordern',
      dashboard: 'Dashboard',
      analysis: 'Analyse',
      list: 'Liste der Unternehmen',
    },
    dashboard: {
      title: 'Dashboard',
    },
    upload: {
      title: 'Umfrage',
      common: 'Allgemein',
    },
    scorecard: {
      title: 'Scorekarte',
      list: 'Liste',
      detail: 'Detail',
      scorecard_detail: 'Scorecard Detail',
      answer_preview: 'Antwort-Vorschau',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: 'Plan zur Verbesserung',
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: 'Erweiterte Analyse',
    },
    settings: {
      title: 'Einstellungen',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: 'FAQs',
    },
    logout: {
      title: 'Abmelden',
    },
    industry: {
      type_1: 'Landwirtschaft, Forstwirtschaft und Fischerei',
      type_2: 'Bergbau, Steinbrüche und Kiesabbau',
      type_3: 'Bauindustrie (einschließlich Anlagenbau)',
      type_4: 'Verarbeitende Industrie (Eisen, Stahl, Nichteisenmetalle, Metallprodukte)',
      type_5: 'Verarbeitendes Industrie (Maschinen, Ausrüstung, Elektronik, usw.)',
      type_6: 'Verarbeitende Industrie (Nahrungsmittel, Getränke, Tabak, usw.)',
      type_7: 'Verarbeitende Industrie (Zellstoff, Papier, Papiererzeugnisse)',
      type_8: 'Verarbeitende Industrie (Holz, Holzprodukte, Verarbeitung)',
      type_9: 'Verarbeitende Industrie (Chemische Industrie, einschließlich Pharmazeutika, Textilindustrie)',
      type_10: 'Verarbeitende Industrie (Erdöl, Kohle, Gummi, Kunststoff usw.)',
      type_11: 'Verarbeitende Industrie (Druckindustrie)',
      type_12: 'Verarbeitende Industrie (Sonstiges)',
      type_13: 'Elektrizitäts-, Gas-, Wärme- und Wasserversorgungsindustrie',
      type_14: 'Informations- und Kommunikationsindustrie',
      type_15: 'Transport- und Lagerhaltungsindustrie',
      type_16: 'Großhandel und Einzelhandel',
      type_17: 'Finanz- und Versicherungswesen',
      type_18: 'Immobilienwirtschaft',
      type_19: 'Schulen (einschließlich Kindergärten und Kindertagesstätten)',
      type_20: 'Beherbergungs- und Gaststättengewerbe',
      type_21: 'Lebensbezogene Dienstleistungen (Wäscherei, Friseur, Kosmetik, Badehaus usw.)',
      type_22: 'Medizinisches und soziales Gewerbe',
      type_23: 'Abfallbeseitigung und Recycling Industrie',
      type_24: 'Autowartungsindustrie',
      type_25: 'Lokale Regierungen, öffentliche Behörden usw.',
      type_26: 'Andere',
    },
    scale: {
      a: '1〜29 Personen',
      b: '30〜99 Personen',
      c: '100〜499 Personen',
      d: '500〜999 Personen',
      e: '1000〜4999 Personen',
      f: 'über 5000 Personen',
    },
    sales_amount: {
      under_1million: '~1Million USD',
      under_10million: '1~10Millionen USD',
      under_100million: '10~100Millionen USD',
      under_1billion: '100Millionen~1Milliarde USD',
      under_10billion: '1~10Mrd. USD',
      over_10billion: '10Milliarden~ USD',
      not_disclose: 'Ich möchte keine Angaben machen',
    },
    progress: 'Fortschritt',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: 'Aufschlüsselung',
    help: 'Hilfe',
    user_display_mode: {
      my_assessment: 'Meine Bewertung',
      supply_chain_assessment: 'Bewertung der Lieferkette',
    },
    buyer: 'Käufer',
    supplier: 'Lieferant',
    error_page: {
      section_one: 'Seite nicht gefunden',
      section_two: 'Bitte überprüfen Sie die URL',
      to_dashboard: 'Zurück zum Dashboard',
    },
    priority: {
      good: 'Gut',
      high: 'Hoch',
      medium: 'Mittel',
      low: 'Niedrig',
    },
    priority_full_name: {
      high: 'Hohes Risiko',
      medium: 'Mittleres Risiko',
      low: 'Geringes Risiko',
    },
    faq: {
      how_to_use_csv_head: 'Um die heruntergeladene CSV-Datei in Excel zu öffnen, folgen Sie bitte den nachstehenden Anweisungen.',
      how_to_use_csv_body_01: '1. Öffnen Sie ein neues leeres Excel-Buch.',
      how_to_use_csv_body_02: "2. Klicken Sie auf der Registerkarte 'Daten' auf 'Aus Text oder CSV'.",
      how_to_use_csv_body_03: "3. Wählen Sie eine CSV-Datei und klicken Sie auf 'Importieren'.",
      how_to_use_csv_body_04: '4. Bestätigen Sie, dass die Datei korrekt importiert wurde.',
      how_to_use_csv_body_05: "5. Wählen Sie 'Laden'.",
      how_to_use_csv_note: '※ Das Verfahren kann je nach Betriebssystem und verwendeter Microsoft Excel-Version variieren.',
    },
    answer_display_status: {
      unanswered: 'Nicht gestartet',
      temporarily_saved: 'In Arbeit',
      submitted: 'Eingereicht',
      score_rated: 'Bewertet',
      ended: 'Geschlossen',
    },
    all: 'Alle',
    count: {
      // question: '',
      company: 'Unternehmen',
      unit: 'Einträge',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: 'Status',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: 'Eingeben',
      half_digits: 'Halbe Ziffern',
    },
  },
};
